import Homepage from "../../apis/homepage";

export default {
  ///////////////////////////////////////////////
  /////////////////ABOUTUS/////////////////////
  /////////////////////////////////////////////

  add_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Homepage.add_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Homepage.getall_aboutUs(payload);
        commit("GET_ABOUT_US", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Homepage.delete_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_aboutUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Homepage.update_aboutUs(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
